export default {"src":"/_next/static/media/logo.b2fd2de8.svg","height":30,"width":114};